/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 240px;
	padding-top: 17px;
	margin: auto;
`;


// WEBPACK FOOTER //
// ./src/components/auth-form/wrapper.js